import React from 'react';
import { getCalculatedMealsCaloriesPricePerDay } from '../../../../redux/selectors/orderFormSelector';
import { parsePrice } from '../../../../utils';
import ForkAndKnifeIcon from '../../../../assets/icons/forkAndKnifeIcon';
import CartIcon from '../../../../assets/icons/cartIcon';
import FireIcon from '../../../../assets/icons/fireIcon';
import Coins2Icon from '../../../../assets/icons/coins2Icon';
import { useAppSelector } from '../../../../config/hooks';

const CalculatedMealsValues = () => {
  const infoPerDay =
    useAppSelector(getCalculatedMealsCaloriesPricePerDay) || {};

  const {
    calculatedDayPrice,
    ingredientCalories,
    selectedMealsLength,
    selectedSideOrdersLength,
  } = infoPerDay;

  const parseText = (number, one, moreThanOne, moreThanFour) => {
    if (number === 1) {
      return `${number} ${one}`;
    }

    if (number > 1 && number < 5) {
      return `${number} ${moreThanOne}`;
    }

    return `${number} ${moreThanFour}`;
  };

  return (
    <div className="display-flex flex-wrap">
      <div className="display-flex align-items-center spacer-top-8">
        <ForkAndKnifeIcon
          className="spacer-right-4 hidden-down-sm"
          color="#8FA1B3"
        />
        <p className="body-m">
          {parseText(selectedMealsLength, 'posiłek', 'posiłki', 'posiłków')}
        </p>
      </div>
      {!!selectedSideOrdersLength && (
        <div className="display-flex align-items-center spacer-top-8 spacer-left-8">
          <span className="body-m spacer-horizontal-4 hidden-up-sm">•</span>
          <CartIcon
            className="spacer-right-4 hidden-down-sm"
            color="#8FA1B3"
            height="24"
            width="24"
          />
          <p className="body-m">
            {parseText(
              selectedSideOrdersLength,
              'dodatek',
              'dodatki',
              'dodatków'
            )}
          </p>
        </div>
      )}
      <div className="display-flex align-items-center spacer-top-8 spacer-left-8">
        <span className="body-m spacer-horizontal-4 hidden-up-sm">•</span>
        <FireIcon className="spacer-right-4 hidden-down-sm" />
        <p className="body-m">{Math.floor(ingredientCalories)} kcal</p>
      </div>
      <div className="display-flex align-items-center spacer-top-8 spacer-left-8">
        <span className="body-m spacer-horizontal-4 hidden-up-sm">•</span>
        <Coins2Icon
          className="spacer-right-4 hidden-down-sm"
          height="24"
          width="24"
        />
        <p className="body-m">{parsePrice(calculatedDayPrice)} zł</p>
      </div>
    </div>
  );
};

export default CalculatedMealsValues;
